import React, { useEffect, useState } from "react";
import ind from "../Assets/icons/india.png";
import CA from "../Assets/icons/canada.png";
import ND from "../Assets/icons/netherlands.png";
import emailIcon from "../Assets/icons/email-icon.svg";
import whiteLogo from "../Assets/images/New/white-logo.png";
import "./Footer.scss";
import { Link } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { getAllSubject } from "../services/getAllSubject";
const baseURL = process.env.REACT_APP_FILE_BASE_URL;

const Footer = () => {
  const [footerLinks, setFooterLinks] = useState([]);
  const [setting, setSetting] = useState([]);
  const [socialMedia, setsocialMedia] = useState([]);
  const [contact, setContact] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
const [cmsData, setCmsData] = useState([]);

  const fetchSubjectData = async () => {
    try {
      const response = await getAllSubject();
      setSubjectData(response.data);
    } catch (error) {
      console.error("Error fetching subject data:", error);
    }
  };

  useEffect(() => {
    fetchSubjectData();
  }, []);

  const formatContactNumber = (countryName, contactNumber) => {
    switch (countryName) {
      case "India":
        return `+${contactNumber.slice(0, 2)} ${contactNumber.slice(
          2,
          7,
        )} ${contactNumber.slice(7)}`;
      case "Canada":
        return `+${contactNumber.slice(0, 1)} (${contactNumber.slice(
          1,
          4,
        )}) ${contactNumber.slice(4, 7)}-${contactNumber.slice(7)}`;
      case "Netherlands":
        return `+${contactNumber.slice(0, 2)} ${contactNumber.slice(
          2,
          5,
        )} ${contactNumber.slice(5, 7)} ${contactNumber.slice(7)}`;
      default:
        return contactNumber;
    }
  };


  useEffect(() => {
  const fetchAllData = async () => {
    try {
      const [
        cmsRes,
        categoryRes,
        settingRes,
        socialRes,
        contactRes,
        subjectRes
      ] = await Promise.all([
        axiosInstance.get("/admin/cms/getAllCMS"),
        axiosInstance.get("/admin/category/getCategoryWiseSubcategory"),
        axiosInstance.get("/admin/setting/getSetting"),
        axiosInstance.get("/admin/socialMedia/getSocialMedia"),
        axiosInstance.get("/admin/contactNumber/getContactNumbers"),
        getAllSubject()
      ]);

      setCmsData(cmsRes.data.data);
      setFooterLinks(categoryRes.data.data);
      setSetting(settingRes.data.data);
      setsocialMedia(socialRes.data.data);
      setContact(contactRes.data.data);
      setSubjectData(subjectRes.data);

    } catch (error) {
      console.error("Error fetching footer data:", error);
    }
  };

  fetchAllData();
}, []);
 
  const getSubCategoriesByCategory = (categoryName) => {
    const subCategory = footerLinks?.find(
      (x) => x?.categoryName === categoryName,
    );
    return subCategory;
  };

  useEffect(() => {
    const rzpPaymentForm = document.getElementById("rzp_payment_form");

    if (!rzpPaymentForm?.hasChildNodes()) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/payment-button.js";
      script.async = true;
      script.dataset.payment_button_id = "pl_O7ZeG8gDz86T7H";
      rzpPaymentForm?.appendChild(script);
    }
  });

  if(subjectData.length === 0 || footerLinks.length === 0 || cmsData.length === 0){
    return null;
  }
  return (
    <div className="footer-section ">
      <div className="container">
        <div className="footer-container ">
          <div>
            <div className="footer-header-custom">
              <div className="footer-logo-wrap">
                <img
                  src={whiteLogo}
                  alt="Footer white logo"
                  className="footer-logo-custom"
                />
              </div>
              <ul className="footer-social-custom">
                {socialMedia?.map((media, index) => (
                  <li key={index}>
                    <Link to={media.url} target="_blank">
                      <img
                        src={`${baseURL}${media.image}`}
                        alt={media.name}
                        className="footer-icon-custom"
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <hr />
            <div className="row">
              <div className="footer-col col-lg-2 col-sm-6 col-md-4 col-12">
                {getSubCategoriesByCategory("Exam Preparation") ? (
                  <>
                    <h3>Exam Preparation</h3>
                    <ul className="p-0">
                      {getSubCategoriesByCategory(
                        "Exam Preparation",
                      )?.subcategories.map((element) => {
                        return (
                          <li key={element.path}>
                            <Link
                              className="text-decoration-none"
                              to={element.path}
                            >
                              {element.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : null}
                {getSubCategoriesByCategory("Live Session Help") ? (
                  <>
                    <h3>Live Session Help</h3>
                    <ul className="p-0">
                      {getSubCategoriesByCategory(
                        "Live Session Help",
                      )?.subcategories.map((element) => {
                        return (
                          <li key={element.path}>
                            <Link
                              className="text-decoration-none"
                              to={element.path}
                            >
                              {element.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : null}
              </div>
              <div className="footer-col col-lg-2 col-sm-6 col-md-4 col-12">
                {getSubCategoriesByCategory("Assignment Help") ? (
                  <>
                    <h3>Assignment Help</h3>
                    <ul className="p-0">
                      {getSubCategoriesByCategory(
                        "Assignment Help",
                      ).subcategories.map((element) => {
                        return (
                          <li key={element.path}>
                            <Link
                              className="text-decoration-none"
                              to={element.path}
                            >
                              {element.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : null}
                {getSubCategoriesByCategory("Homework Help") ? (
                  <>
                    <h3>Homework Help</h3>
                    <ul className="p-0">
                      {getSubCategoriesByCategory(
                        "Homework Help",
                      )?.subcategories.map((element) => {
                        return (
                          <li key={element.path}>
                            <Link
                              className="text-decoration-none"
                              to={element.path}
                            >
                              {element.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : null}
              </div>
              <div className="footer-col col-lg-4 col-sm-6 col-md-4 col-12">
                <>
                  <h3>Subjects</h3>
                  <ul className="p-0 pl-4">
                    {subjectData
                      .filter((sub) => sub.showInFooter)
                      .map((sub) => (
                        <li key={sub.subjectUrl}>
                          <Link
                            className="text-decoration-none"
                            to={`/subject/${sub.subjectUrl}`}
                          >
                            {sub.questionSubject} Assignment Help
                          </Link>
                        </li>
                      ))}
                  </ul>
                </>
              </div>
              <div className="footer-col col-lg-2 col-sm-6 col-md-4 col-12">
                <h3>About Us</h3>
                <ul className="p-0">
                  <li>
                    <Link to="/become-a-tutor" className="text-decoration-none">
                      Become a tutor
                    </Link>
                  </li>
                  <li>
                    <Link to="/faqs" className="text-decoration-none">
                      FAQ's
                    </Link>
                  </li>
                  <li>
                    <Link to="/reviews" className="text-decoration-none">
                      Reviews
                    </Link>
                  </li>
                  {cmsData.map((data, i) => {
                    return (
                      <li key={i}>
                        <Link
                          to={`/${data.slug}`}
                          className="text-decoration-none"
                        >
                          {data.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="footer-col col-lg-2 col-sm-6 col-md-4 col-12">
                <h3>Contact Us</h3>
                <ul className="p-0">
                  {contact
                    .filter((c) => c.showInFooter || c.showInHeader)
                    .map((c, index) => {
                      if (c.showInFooter) {
                        const countryFlag =
                          c.countryName === "Canada"
                            ? CA
                            : c.countryName === "Netherlands"
                              ? ND
                              : ind;

                        return (
                          <li key={index} className="li-icon">
                            <Link
                              to={`https://wa.me/${c.contactNumber}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="whatsapp-link"
                              style={{fontSize:"13px"}}
                            >
                              <img
                                // className="mt-1"
                                src={countryFlag}
                                alt={`${c.countryName} WhatsApp Icon`}
                                height={16}
                                width={16}
                              />
                              {c.countryName}:{" "}
                              {formatContactNumber(
                                c.countryName,
                                c.contactNumber,
                              )}
                            </Link>
                          </li>
                        );
                      }
                      return null;
                    })}
                  <li className="li-icon" >
                    <Link
                      to={`mailto:${setting?.contactEmail}`}
                      className="email-link"
                    >
                      <img
                        className="mt-1"
                        src={emailIcon}
                        alt="Email Icon"
                        height={13}
                        width={13}
                      />
                      {` ${setting?.contactEmail}`}
                    </Link>
                  </li>
                </ul>
              </div>
              <hr />
              <div className="footer-end-section">
                <span>
                  <h3>
                    © {new Date().getFullYear()} DoubtQ. All Rights Reserved
                  </h3>
                </span>
                <div className="d-flex">
                  <p
                    dangerouslySetInnerHTML={{ __html: setting?.disclaimer }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
